<template>
    <b-card-body flush>
        <multiselect
            :options="listArray"
            :loading="list.loading"
            track-by="id"
            label="name"
            v-model="memberships"
            :multiple="true"
        ></multiselect>
        <br />
        <b-form-group>
            <b-btn variant="primary" block @click="applyMemberships">Add</b-btn>
        </b-form-group>
    </b-card-body>
</template>
<script>
import GenericCollection from '@/models/GenericCollection'

import { pluralize } from 'inflected'

const defaultValidator = function(value) {
    return ['user', 'group', 'form'].indexOf(value) > -1 ? true : false
}

export default {
    props: {
        context_type: {
            type: String,
            default: 'member',
        },
        context: {
            type: Object,
            required: true,
        },
        entities_present: {
            type: Object,
            required: true,
        },
        member_type: {
            type: String,
            required: true,
            validator: defaultValidator,
        },
        list_type: {
            required: true,
            type: String,
            validator: defaultValidator,
        },
    },

    data() {
        return {
            model: {},
            list: new GenericCollection(),
            memberships: [],
            transformed_members: [],
        }
    },

    created() {
        let list = this.list

        //let memberships = this.memberships
        //memberships.setResourceName('groupmembers')

        // Load list
        list.setResourceName(pluralize(this.list_type))
            .setFilter({
                company_id: this.context.company_id,
            })
            .setPerPage(10000)

        list.fetch()
    },

    computed: {
        listArray() {
            let presentEntities = this.entities_present.models.map(item => {
                if (this.context_type == 'group' && item._attributes.member) {
                    return item._attributes.member.id
                }
                if (this.context_type == 'member' && item._attributes.group) {
                    return item._attributes.group.id
                }
                return
            })
            let listArray = this.list.filter(entity => {
                return presentEntities.indexOf(entity._attributes.id) <= -1
            })
            return listArray.models
                .map(item => {
                    return {
                        id: item.id,
                        name: item.display_name,
                    }
                })
                .sort((a, b) => {
                    return a.name.localeCompare(b.name)
                })
        },
    },

    methods: {
        applyMemberships() {
            this.transformed_members = this.memberships.map(membership => {
                let _membership = {}

                _membership.member_id = this.context.id
                _membership.group_id = membership.id

                if (this.context_type == 'group') {
                    _membership.member_id = membership.id
                    _membership.group_id = this.context.id
                }

                _membership.member_type = this.member_type

                membership = this.list.createModel(_membership)
                membership.setResourceName('groupmembers')
                membership.save()
                return membership
            })
        },
    },
}
</script>
